var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import moment from "moment";
import authentication from "@irati/auth";
import Bar from "@irati/ui/src/Bar";
import { H2 } from "@irati/ui/src/Headings";
import { SmallCaption } from "@irati/ui/src/Labels";
import Card from "@irati/ui/src/Layout/Card";
import InfoTooltip from "@irati/ui/src/FormItem/utils/InfoTooltip";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { getStats } from "@irati/medical/services/medical";
import Loading from "@irati/ui/src/Loading";
import medicalTracking from "@irati-tracking/medical";
import DownloadReport from "@irati-web/medical/src/components/DownloadReport/DownloadReport";
import NumberAndText from "../../components/NumberAndText";
import SignedUpAndRemaining from "../../components/SignedUpAndRemaining";
import { Grid } from "../../components/shared";
import { Tracker, CenteredButton, EmployeeTotalWrapper, EmployeeTotal, InlinePara, TooltipWrapper, HeadingFlex } from "./styled";
var Reports = /** @class */ (function (_super) {
    __extends(Reports, _super);
    function Reports(props) {
        var _this = _super.call(this, props) || this;
        _this.getDate = function () {
            if (moment().isBefore(moment()
                .hour(2)
                .minute(0)
                .second(0))) {
                return moment()
                    .subtract(1, "days")
                    .format("DD/MM/YYYY");
            }
            return moment().format("DD/MM/YYYY");
        };
        medicalTracking.viewReports();
        _this.state = {
            load: getStats().then(function (_a) {
                var totalLicenses = _a.totalLicenses, numberActivated = _a.numberActivated;
                return _this.setState({ totalLicenses: totalLicenses, numberActivated: numberActivated });
            }),
            totalLicenses: 0,
            numberActivated: 0
        };
        return _this;
    }
    Reports.prototype.render = function () {
        var _a = this.state, totalLicenses = _a.totalLicenses, numberActivated = _a.numberActivated, load = _a.load;
        var formatMessage = this.props.formatMessage;
        return (React.createElement(Grid, null,
            React.createElement(Loading, { load: load },
                React.createElement(HeadingFlex, null,
                    React.createElement(H2, { base: true },
                        React.createElement(FormattedMessage, { id: "medical.reports.title" })),
                    React.createElement(SmallCaption, null,
                        React.createElement(FormattedMessage, { id: "medical.reports.lastUpdated", values: { date: this.getDate() } }))),
                React.createElement(InlinePara, { large: true },
                    React.createElement(FormattedMessage, { id: "medical.reports.para" })),
                React.createElement(TooltipWrapper, null,
                    React.createElement(InfoTooltip, { tooltip: formatMessage({ id: "medical.reports.tooltip" }), position: "bottom", customIcon: true })),
                React.createElement(Tracker, null,
                    React.createElement(EmployeeTotalWrapper, null,
                        React.createElement(EmployeeTotal, null,
                            React.createElement(NumberAndText, { number: totalLicenses, text: "medical.reports.employees.total" }))),
                    React.createElement(Card, null,
                        React.createElement(Bar, { delay: true, score: numberActivated, maxScore: totalLicenses }),
                        React.createElement(SignedUpAndRemaining, { numberActivated: numberActivated, totalLicenses: totalLicenses }))),
                React.createElement(DownloadReport, { Comp: CenteredButton, large: true, centre: true, trackingEventName: "medical_download_report", tenant: authentication.userTenant() },
                    React.createElement(FormattedMessage, { id: "medical.reports.employees.button" })))));
    };
    return Reports;
}(Component));
export default injectIntl(Reports);
